module.exports = __webpack_public_path__ + "img/闪电02.9b84f38c.svg";